import { IIconBase } from '..'

const closeIcon = ({
  color = '#5A607F',
  height = 25,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/add'>
        <g id='add'>
          <path
            id='Vector'
            d='M6.02148 6L12.3639 12.3854'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M5.99987 12.3641L12.3853 6.02161'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default closeIcon
